import axios from 'axios';

const getMoedasComprador = idEncoded => axios.get(`/external/moedas/solicitacoes/${idEncoded}`);

export default {
  getMoedasComprador,
};
